/**
 * @param config
 * @returns A function that removes the listeners it created.
 */
export default function onVisibilityChange(
  config: IOnVisibleChangeConfig
): () => void {
  let visibilityState
  let visibilityChange

  if (typeof document.hidden !== 'undefined') {
    visibilityChange = 'visibilitychange'
    visibilityState = 'visibilityState'
  } else if (typeof document.mozHidden !== 'undefined') {
    visibilityChange = 'mozvisibilitychange'
    visibilityState = 'mozVisibilityState'
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange'
    visibilityState = 'msVisibilityState'
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange'
    visibilityState = 'webkitVisibilityState'
  }

  function handleVisibilityChange() {
    switch (document[visibilityState]) {
      case 'visible':
        config.onVisible()
        break
      case 'hidden':
        config.onHidden()
        break
      default:
        break
    }
  }

  document.addEventListener(visibilityChange, handleVisibilityChange, false)

  // Return a function that when called, removed the eventListener
  return () => {
    document.removeEventListener(
      visibilityChange,
      handleVisibilityChange,
      false
    )
  }
}

export interface IOnVisibleChangeConfig {
  onVisible: Function
  onHidden: Function
}
